<div class="readonly-container" *ngIf="isReadOnly">
    <div class="readonly-body">Read-Only</div>
</div>